import React, { useState } from 'react'
import { Dialog } from '@material-ui/core'
import Recaptcha from 'react-google-invisible-recaptcha'
import Loading from './Loading'
import axios from 'axios'
import utils from 'Utils'

const ModalRegisterDoctor = ({ open, onClose, snackbar }) => {
    const [doctor, setDoctor] = useState({ fullname: '', mobile: '' })
    const [isLoaded, setIsLoaded] = useState(false)
    const recaptcha = React.useRef();

    const handleDoctorInfo = name => e => setDoctor({ ...doctor, [name]: e.target.value });

    const onSubmit = () => {
        const isMobileNum = /09\d{9}/

        if (!doctor.fullname || !doctor.mobile) {
            if (!doctor.fullname) snackbar('نام و نام خانوادگی وارد نشده است!')
            if (!doctor.mobile) snackbar('شماره تماس وارد نشده است!')
            if (!doctor.fullname && !doctor.mobile) snackbar('لطفا فیلدهای خالی را پر کنید.')

            return recaptcha.current.reset()
        } else {
            if (!isMobileNum.test(doctor.mobile)) {
                return snackbar('لطفا شماره تماس را صحیح وارد کنید.')
            } else {
                recaptcha.current.execute()
                return setIsLoaded(true)
            }
        }
    }

    const sendDoctorInfo = () => {
        axios.post(utils.urls.sendDoctorInfoUrl, {
            'g-recaptcha-response': recaptcha.current.getResponse(),
            telephone: recaptcha.current.props.doctor.mobile.trim(),
            fname: 'دکتر',
            lname: recaptcha.current.props.doctor.fullname.trim(),
            email: 'ندارد',
            message: 'درخواست دکتر از صفحه مشاوره آنلاین'
        })
            .then(res => {
                setIsLoaded(false)
                setDoctor({ fullname: '', mobile: '' })
                onClose()
                snackbar('اطلاعات شما ثبت شد و به زودی با شما تماس خواهیم گرفت', 'info')
            })
            .catch(err => {
                console.log(err)
                snackbar('مشکلی بوجود آمده است!')
            })
    }

    return (
        <Dialog
            onClose={onClose}
            open={open}
        >
            <div className="doctor-info-modal">
                <div>
                    <h3>ثبت نام رایگان نرم افزار مشاوره آنلاین</h3>
                </div>
                <p>با پر کردن فرم زیر همکاران ما با شما تماس گرفته و مراحل ثبت نام شما در سامانه مشاوره آنلاین انجام خواهد شد.</p>
                <div className="input-box">
                    <div className="input-box__item">
                        <input
                            placeholder="نام و نام خانوادگی"
                            value={doctor.fullname}
                            onChange={handleDoctorInfo('fullname')}
                        />
                    </div>
                    <div className="input-box__item">
                        <input
                            placeholder="شماره تماس پزشک"
                            value={doctor.mobile}
                            onChange={handleDoctorInfo('mobile')}
                        />
                    </div>
                </div>
                <button className="btn" onClick={onSubmit}>ثبت</button>
                {isLoaded ? <Loading /> : null}
                <Recaptcha
                    ref={recaptcha}
                    sitekey={'6LefwWQUAAAAAIZUwjTXBouvcDpmb3FqQ6mxJRyc'}
                    onResolved={sendDoctorInfo}
                    doctor={doctor}
                />
            </div>
        </Dialog>
    )
}

export default ModalRegisterDoctor
